import React from 'react';
import DataTable from '../data_tables/DataTable';
import API_ENDPOINTS from '../ApiEndPoints';

class ViewList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false // Change this to false so that the DataTable is rendered immediately
        };
    }

    componentDidMount() {
        console.log('ViewList component mounted');
        // Verify API endpoints are properly loaded
        console.log('API endpoints available:', API_ENDPOINTS);
    }

    render() {
        // Configure fields to display in the table with maxLength settings
        const fields = [
            { key: 'id', label: 'ID', maxLength: 10 },
            { key: 'title', label: 'Title', maxLength: 50 },
            { key: 'description', label: 'Description', maxLength: 100 },
            { key: 'tags', label: 'Tags' },
            { key: 'created_at', label: 'Date Created' },
            { key: 'updated_at', label: 'Date Updated' },
            { key: 'tid', label: 'TID' },
            { key: 'owner_id', label: 'Created By' }
        ];

        // Define sortable fields
        const sortableFields = [
            { key: 'id', label: 'ID' },
            { key: 'title', label: 'Title' },
            { key: 'owner_id', label: 'Created By' },
            { key: 'created_at', label: 'Date Created' },
            { key: 'updated_at', label: 'Date Updated' },
            { key: 'tid', label: 'TID' }
        ];

        // Verify apiEndpoint before passing to DataTable
        const apiEndpoint = API_ENDPOINTS?.list?.all || '/api/v1/list/all';
        const userApiEndpoint = API_ENDPOINTS?.user?.all || '/api/v1/user/all';

        console.log('Using API endpoint:', apiEndpoint);
        console.log('Using user API endpoint:', userApiEndpoint);

        // Configure action buttons with icons matching the existing system styling
        const actionButtons = [
            {
                label: <i className="ti-eye" title="View"></i>,
                onClick: (item) => window.location.href = `/list/view/${item.id}`,
                className: 'btn btn-primary btn-xs my-1'
            },
            {
                label: <i className="ti-pencil" title="Edit"></i>,
                onClick: (item) => window.location.href = `/items/${item.id}/edit`,
                className: 'btn btn-primary btn-xs my-1'
            },
            {
                label: <i className="fa fa-file-text-o" title="Edit"></i>,
                onClick: (item) => window.location.href = `/items/${item.id}/edit`,
                className: 'btn btn-primary btn-xs my-1'
            },
            {
                label: <i className="ti-files" title="Duplicate"></i>,
                onClick: (item) => {
                    console.log('Duplicating item', item.id);
                    // Implement duplicate logic here
                },
                className: 'btn btn-primary btn-xs my-1'
            },
            {
                label: <i className="ti-trash" title="Delete"></i>,
                onClick: (item) => {
                    if (confirm('Are you sure you want to delete this item?')) {
                        console.log('Deleting item', item.id);
                        // Implement delete logic here
                    }
                },
                className: 'btn btn-primary btn-xs my-1'
            }
        ];

        // Additional props to configure the action buttons container
        const actionButtonsConfig = {
            containerClass: 'flex space-x-1 justify-content-end'
        };

        return (
            <div className="view-list-component">
                <h1>List Items</h1>

                <DataTable
                    apiEndpoint={apiEndpoint}
                    fields={fields}
                    actionButtons={actionButtons}
                    actionButtonsConfig={actionButtonsConfig}
                    userIdFields={['owner_id']}
                    userApiEndpoint={userApiEndpoint}
                    title=""
                    defaultItemsPerPage={10}
                    itemsPerPageOptions={[5, 10, 25, 50]}
                    sortableFields={sortableFields}
                    defaultSortField="title"
                    defaultSortOrder="asc"
                    enableUserFilter={true} // Enable the user filter
                    userFilterLabel="Filter by creator:"
                    defaultUserId="" // Default to show all users
                    defaultMaxLength={80} // Default max length for all fields
                />
            </div>
        );
    }
}

export default ViewList;
